import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  template: `
    <h2 mat-dialog-title>Tags added to List</h2>
    <mat-dialog-content>
      <mat-chip-listbox [selectable]="false">
        <mat-chip-option *ngFor="let tag of tags">
          {{ tag }}
        </mat-chip-option>
      </mat-chip-listbox>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button matDialogClose>Close</button>
    </mat-dialog-actions>
  `,
  styleUrls: ['../../common/dialog.component.scss', './action-lists-tags-dialog.component.scss'],
  standalone: false,
})
export class ActionListTagsDialogComponent {
  tags: string[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: { tags: string[] }) {
    this.tags = data.tags;
  }
}
